import qs from 'qs';
export async function restRequest(endpoint, init, options) {
    var _a, _b, _c, _d;
    const args = Object.assign({
        sendWpNonce: true,
    }, options || {});
    const url = (((_b = (_a = window.THEME) === null || _a === void 0 ? void 0 : _a.REST) === null || _b === void 0 ? void 0 : _b.base) || '/wp-json/') + (endpoint.startsWith('/') ? endpoint.substring(1) : endpoint);
    const request = new Request(url, init);
    request.headers.set('Content-Type', 'application/json');
    request.headers.set('Accept-Content-Type', 'application/json');
    request.headers.set('credentials', 'same-origin');
    if (args === null || args === void 0 ? void 0 : args.sendWpNonce) {
        request.headers.set('X-WP-Nonce', (_d = (_c = window.THEME) === null || _c === void 0 ? void 0 : _c.REST) === null || _d === void 0 ? void 0 : _d.nonce);
    }
    if (typeof (args === null || args === void 0 ? void 0 : args.modify) === 'function') {
        args.modify(request);
    }
    return fetch(request);
}
export async function restRequestTheme(method, endpoint, args = {}) {
    const urlArgs = args.urlArgs ? qs.stringify(args.urlArgs) : '';
    const url = `theme/${endpoint}${urlArgs ? `?${urlArgs}` : ''}`;
    const response = await restRequest(url, Object.assign({
        method: method.toUpperCase(),
    }, args.init || {}), args.options);
    const json = await response.json();
    return response.ok ? json : Promise.reject(json);
}
export async function restRequestThemePart(method, partType, themePart, action = '', args = {}) {
    const urlArgs = args.urlArgs ? qs.stringify(args.urlArgs) : '';
    const url = ['theme', partType, themePart, action].filter(Boolean).join('/') + (urlArgs ? `?${urlArgs}` : '');
    const response = await restRequest(url, Object.assign({
        method: method.toUpperCase(),
    }, args.init || {}), args.options);
    const json = await response.json();
    return response.ok ? json : Promise.reject(json);
}
